export function on (element, event, handler) {
  if (element && event && handler) {
    document.addEventListener ? element.addEventListener(event, handler, false) : element.attachEvent('on' + event, handler)
  }
}
export function off (element, event, handler) {
  if (element && event) {
    document.removeEventListener ? element.removeEventListener(event, handler, false) : element.detachEvent('on' + event, handler)
  }
}
export function elementContains (elm, otherElm) {
  if (typeof elm.contains === 'function') {
    return elm.contains(otherElm)
  }
  return false
}
